import axios from "axios";
import {API_DELIVERY_POINT_DIRECTIVES} from '../api.js';

export default {
    async remove(data, options = {}) {
        return await axios.delete(`${API_DELIVERY_POINT_DIRECTIVES}/${data.id}`, options);
    }
};
